import { isNil } from 'lodash-es';
import { useRouter } from 'next/router';

const USER_ID_KEY = 'userId';

export default function useQueryHandleWithUserId({
  fallbackKey,
}: {
  fallbackKey?: string;
} = {}) {
  const router = useRouter();

  function getCurrentUserId() {
    const userIdValue = router.query[USER_ID_KEY];
    const fallbackValue = !isNil(fallbackKey) ? router.query[fallbackKey] : undefined;

    return (
      (typeof userIdValue === 'string' ? userIdValue : undefined) ||
      (typeof fallbackValue === 'string' ? fallbackValue : undefined) ||
      undefined
    );
  }

  function hasUserId() {
    return Boolean(getCurrentUserId());
  }

  function makePathWithUserId(path: string) {
    return `${path}?${USER_ID_KEY}=${getCurrentUserId()}`;
  }

  return {
    USER_ID_KEY,
    hasUserId,
    getCurrentUserId,
    makePathWithUserId,
  };
}
